import { Component, EventListener } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import { setCookie } from '@swisslife/shared-ui/src/utils/cookies/js/cookies';

enum Selectors {
	Item = '.js-m-language-selector__item',
}

// The @Component decorator will connect the class with `data-g-name="LanguageNavigation"` elements.
@Component('LanguageNavigation')
export class LanguageNavigation extends GondelJqueryComponent {
	/**
	 * Website selector click
	 * @param ev {MouseEvent}		native event
	 */
	@EventListener('click', Selectors.Item)
	private _handleLanguageSelectorItemClick(ev: MouseEvent) {
		const $target = $(ev.currentTarget!);
		setCookie($target.data('cookie-name'), $target.data('cookie-value'));
	}
}
